import { render, staticRenderFns } from "./purrfqbpart.vue?vue&type=template&id=598e8e78&scoped=true&"
import script from "./purrfqbpart.vue?vue&type=script&lang=js&"
export * from "./purrfqbpart.vue?vue&type=script&lang=js&"
import style0 from "./purrfqbpart.vue?vue&type=style&index=0&id=598e8e78&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "598e8e78",
  null
  
)

export default component.exports